import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RequestState, RequestStateEnum } from "@app-common/http/RequestState";
import { numbersWithDecimal } from "@app-module/shared/shared.constants";
import { BeneficiaryService } from "@app-service/beneficiary.service";
import { CardApplicationDetailsService } from "@app-service/card-application-details.service";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { CreditLimitContant } from "@app/admin/dashboard-cards/credit-limit-popup/credit-limit-constant";
// import { CreditLimitContant } from "@app/admin/dashboard-cards/credit-limit-popup/credit-limit-constant";
import { Subscription } from "rxjs";
@Component({
    selector: "app-create-outstanding-popup",
    templateUrl: "./create-outstanding-popup.component.html",
    styleUrls: ["./create-outstanding-popup.component.scss"],
    standalone: false
})
export class CreateOutstandingPopupComponent implements OnInit {
  private valueChangesSub: Subscription[] = [];
  @ViewChild("modal") modal: PopupLayoutComponent;
  randomId: string;
  form: FormGroup = new FormGroup({
    amount: new FormControl("", [
      Validators.required,
      Validators.min(1),
      Validators.pattern(numbersWithDecimal),
      Validators.max(990000000),
    ]),
    remarks: new FormControl(null, [
      Validators.maxLength(250),
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9,.\s]+$/),
    ]),
    transactionType: new FormControl(null, [Validators.required]),
  });

  @Input()
  companyID: string;

  constructor(
    private toasterService: ToasterService,
    private beneficiaryService: BeneficiaryService,
    private cardApplicationDetailsService: CardApplicationDetailsService
  ) {
    this.submitRequestState = RequestState.init();
  }
  submitRequestState: RequestState;
  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }

  get allocationAmount() {
    return this.form.get("amount");
  }

  ngOnInit(): void {
    this.randomId = this.generateRandomId(16);
  }

  generateRandomId(length: number): string {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      result += charset.charAt(randomIndex);
    }

    return result;
  }

  getNumberToWords(number): string {
    let words = this.cardApplicationDetailsService.convertNumberToWords(number);
    return words ? words + "Rupees" : "";
  }

  openSnackBar(message: string, type) {
    this.toasterService.showToaster(message, type);
  }
  onSave(): void {
    if (this.submitRequestState.isPending()) {
      return;
    }
    this.submitRequestState.pending();

    const payload = {
      companyId: this.companyID,
      amount: +this.form.get("amount").value,
      referenceId: this.randomId,
      transactionType: this.form.get("transactionType").value,
      remarks: this.form.get("remarks").value,
    };

    this.valueChangesSub.push(
      this.beneficiaryService.createOutstanding(payload).subscribe(
        (item) => {
          if (item && item["payload"]) {
            this.submitRequestState.completed();
            this.modal.close(payload);
            // this.onSaveEmitter.emit({ ...item["payload"] });
          }
        },
        (error) => {
          this.openSnackBar(
            error[CreditLimitContant.error][CreditLimitContant.payload],
            ToasterType.ERROR
          );
          this.submitRequestState.completed();
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.valueChangesSub.map((s) => s.unsubscribe);
  }
}
